module.exports = __webpack_public_path__ + "static/img/taxcellent_content.3a044f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h5/matrix/taxcellent_content.png
// module id = yjPY
// module chunks = 34